import { ReactNode } from 'react';
import { useNotImplemented } from '../activity-feed-utils';
import { useOracleEventCounts } from '../useOracleEventCounts';
import { CheckFilterSection } from './CheckFilterSection';

// Starred and pinned rows are placeholder filters — the underlying state lives in our own
// Postgres (not yet implemented), so the counts endpoint returns -1 for both today. The
// badges render the literal -1 so the missing implementation is visible on-screen rather
// than silently absent. Clicking either checkbox fires useNotImplemented until mutations ship.

type StarredPinnedValue = 'starred' | 'pinned';

const STARRED_PINNED_OPTIONS: { label: string; value: StarredPinnedValue }[] = [
  { label: 'Starred', value: 'starred' },
  { label: 'Pinned for the team', value: 'pinned' }
];

export const StarredPinnedSection = (): ReactNode => {
  const notImplemented = useNotImplemented();
  const counts = useOracleEventCounts();

  return (
    <CheckFilterSection<StarredPinnedValue>
      label='Starred & pinned'
      options={STARRED_PINNED_OPTIONS}
      isChecked={() => false}
      onToggle={() => notImplemented()}
      counts={{ starred: counts?.starred ?? 0, pinned: counts?.pinned ?? 0 }}
    />
  );
};
